import { createFileRoute } from '@tanstack/react-router'
import { BrandCampaignLanding, brandCampaignHead, loadBrandCampaign } from '../components/BrandCampaignLanding'
import { getBrandCampaign } from '../data/brandCampaigns'

const campaign = getBrandCampaign('cd-oreo')!
export const Route = createFileRoute('/cd-oreo')({ loader: () => loadBrandCampaign(campaign), head: () => brandCampaignHead(campaign), component: Page })
function Page() { return <BrandCampaignLanding data={{ ...Route.useLoaderData(), campaign }} /> }
